import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { HomeRouteService } from './home-route.service';

/**
 * Guards the Super Admin console: requires an authenticated user with the
 * Administrator role. Unauthenticated → login; wrong role → the user's landing page.
 */
export const adminRoleGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/account/login'], { queryParams: { returnUrl: state.url } });
  }
  if (!auth.hasAnyRole('Administrator')) {
    return inject(HomeRouteService).resolve().pipe(map((url) => router.parseUrl(url)));
  }
  return true;
};
